module.exports = __webpack_public_path__ + "img/portrait-077.2b698c60.jpg";